import "./ReportCard.css";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { fetchCourseData } from "../../Redux/StudentRegistration/courseSlice";
import FormInputs from "../Reports/DummyReportPage/FormInputs";
import DropDown from "../Reports/DummyReportPage/Dropdown";
import { API_BASE_URL } from "../../Config/Config";
import * as FileSaver from "file-saver";
import * as ExcelJS from "exceljs";

const ReportCard = () => {
  const dispatch = useDispatch();

  const [showModalSider, setShowModalSider] = useState(false);
  const [animationSider, setAnimationSider] = useState("");

  const openModalSider = () => {
    setAnimationSider("active");
    setShowModalSider(true);
  };

  const closeModalSider = () => {
    setAnimationSider("");
    setTimeout(() => setShowModalSider(false), 500);
  };

  useEffect(() => {
    if (!showModalSider && animationSider !== "active") {
      setAnimationSider("closing");
    }
  }, [showModalSider]);

  const { coursesdata } = useSelector((state) => state.course);
  const [testnamedata, setTestNameData] = useState([]);
  const [batchData, setBatchData] = useState([]);
  const [value, setValues] = useState({
    report_title: "",
    course_id: "",
    batch_id: "",
    assessment_id: "",
    start_month: "",
    end_month: "",
    description: "",
    recurrence: "",
  });

  useEffect(() => {
    dispatch(fetchCourseData());
  }, [dispatch]);

  const fetchBatchesByCourse = async () => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-batches-by-course/?course_id=${value.course_id}`
      );
      const data = await response.json();
      setBatchData(data);
    } catch (error) {
      Swal.fire({
        title: "Error!",
        text: error.message,
        icon: "error",
        confirmButtonText: "OK",
      }).then(() => {
        window.location.reload();
      });
    }
  };

  useEffect(() => {
    if (value.course_id) {
      fetchBatchesByCourse();
    }
  }, [value.course_id]);

  const fetchTestDetailsByBatch = async () => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-assessment-detail-by-batch-id/?batch_id=${value.batch_id}&assessment_type_id=2`
      );
      const data = await response.json();
      setTestNameData(data);
    } catch (error) {
      Swal.fire({
        title: "Error!",
        text: error.message,
        icon: "error",
        confirmButtonText: "OK",
      }).then(() => {
        // window.location.reload();
      });
    }
  };

  useEffect(() => {
    if (value.batch_id) {
      fetchTestDetailsByBatch();
    }
  }, [value.batch_id]);

  const onChange = (e) => {
    const { name, value: inputValue, type } = e.target;

    if (type === "radio" && name === "recurrence") {
      setValues((prevState) => ({
        ...prevState,
        recurrence: inputValue,
      }));
    } else {
      setValues((prevState) => ({
        ...prevState,
        [name]: inputValue,
      }));
    }
  };

  const generateReport = async () => {
    openModalSider();

    try {
        const response = await fetch(
            `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-result-dictionary/?assessment_id=${value.assessment_id}`
        );

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        if (data.data.length === 0) {
            Swal.fire({
                title: "No Data",
                text: `Report data for ${value.assessment_name} not found. Please ensure that OMR files are uploaded in case of test via OMR or the test is attempted by students in case of an online test.`,
                icon: "info",
                confirmButtonText: "OK",
            });
        } else {
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet("Report");
            const currentDate = new Date();
            const day = currentDate.getDate();
            const month = currentDate.toLocaleString("default", { month: "short" });
            const year = currentDate.getFullYear();

            // Header rows
            worksheet.addRow([`           DEFINITE SUCCESS`]);
            worksheet.addRow([`           Result Of ${value.assessment_name}`]);
            worksheet.addRow([
                `Test Date:-00-Month-00`,
                ``,
                ``,
                ``,
                `Checking Date:-${day}-${month}-${year}`,
            ]);
            worksheet.addRow([]);

            // Style headers
            worksheet.getRow(1).font = { name: "Arial", size: 28, bold: true };
            worksheet.getRow(2).font = { name: "Arial", size: 27, bold: false };

            // Column headers
            worksheet.addRow([
                "Roll Number",
                "Name",
                "Physics",
                "Chemistry",
                "Biology",
                "Botany",
                "Zoology",
                "Social",
                "Maths",
                "Total Marks",
                "Percentage Obtained",
                "Rank",
                "Percentile",
                "Topper Marks",
            ]);

            worksheet.getRow(4).font = { name: "Arial", size: 10, bold: true };

            // Process and add rows
            data.data.forEach(student => {
                worksheet.addRow([
                    student.roll_number,
                    `${student.student_first_name} ${student.student_last_name}`,
                    student.Physics || "",
                    student.Chemistry || "",
                    student.Biology || "",
                    student.Botany || "",
                    student.Zoology || "",
                    student.Social || "",
                    student.Maths || "",
                    student.total_marks,
                    student.percentage_obtained,
                    student.rank,
                    student.percentile,
                    student.topper_marks
                ]);
            });

            // Add borders to all cells with data
            worksheet.eachRow((row, rowNumber) => {
                if (rowNumber > 4) {
                    row.eachCell((cell) => {
                        cell.border = {
                            top: { style: "thin", color: { argb: "000000" } },
                            bottom: { style: "thin", color: { argb: "000000" } },
                            left: { style: "thin", color: { argb: "000000" } },
                            right: { style: "thin", color: { argb: "000000" } },
                        };
                    });
                }
            });

            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
            });
            FileSaver.saveAs(blob, `Report_Card_${value.assessment_name}.xlsx`);
        }
    } catch (error) {
        Swal.fire({
            title: "Error!",
            text: error.message,
            icon: "error",
            confirmButtonText: "OK",
        });
    }
    closeModalSider();
};


  return (
    <div className="container-otc">
      <div className="container-UP" style={{ position: "sticky", top: "0" }}>
        <div className="Header-up ">
          <p className="title-cb ">Report Card</p>
          <div className="mb-2-UP grey-color-font">
            <button className="cr-cancel-btn me-cs4">CANCEL</button>
          </div>
        </div>
        <hr className="hr-otc" />
        <p style={{ marginTop: "8px" }}>
          View, create, or filter reports. View and manage the list of reports
          already available or create a new report.
        </p>

        <div className="generate-report-container-ReportCard">
          <div className="generate-report-item1-ReportCard">
            <FormInputs
              label="Report Title"
              type="text"
              name="report_title"
              value={value.report_title}
              onChange={onChange}
            />
          </div>
          <div className="generate-report-item2-ReportCard">
            <DropDown
              label="Course"
              setSelected={(selectedOption) =>
                setValues({ ...value, course_id: selectedOption })
              }
              options={
                coursesdata
                  ? coursesdata.map((course) => ({
                      label: course.course_description,
                      id: course.course_id,
                    }))
                  : ""
              }
            />
          </div>
          <div className="generate-report-item3-ReportCard">
            <DropDown
              label="Batch"
              setSelected={(selectedOption) =>
                setValues({ ...value, batch_id: selectedOption })
              }
              options={batchData.map((batch) => ({
                label: batch.batch_code,
                id: batch.batch_id,
              }))}
              Height="auto"
              OverFlow="auto"
              minheight="300px"
            />
          </div>
          <div className="generate-report-item4-ReportCard">
            <DropDown
              label="Test"
              setSelected={(selectedOption) => {
                const selectedTest = testnamedata.find(
                  (test) => test.assessment_id === selectedOption
                );
                setValues({
                  ...value,
                  assessment_id: selectedOption,
                  assessment_name: selectedTest.assessment_name,
                });
              }}
              options={
                testnamedata.length > 0
                  ? testnamedata.map((test) => ({
                      label: test.assessment_name,
                      id: test.assessment_id,
                    }))
                  : [{ label: "No tests available", id: "" }]
              }
              Height="auto"
              OverFlow="auto"
              minheight="300px"
            />
          </div>
          <div className="generate-report-item4-ReportCard">
            <div className="description-ReportCard">
              <label>Description</label>
              <textarea
                name="description-ReportCard"
                value={value.description}
                onChange={onChange}
                placeholder="Write your description here..."
              />
            </div>
          </div>
        </div>
        <div className="SiderNotification">
          {showModalSider && (
            <div className={`modalSider ${animationSider}`}>
              <h2>LOADING</h2>
              <p>Please wait processing data ... </p>
            </div>
          )}
        </div>
        <button
          className="generate-report-btn-ReportCard"
          onClick={generateReport}
        >
          Generate Report
        </button>
      </div>
    </div>
  );
};

export default ReportCard;
